import * as React from "react";
import type { SVGProps } from "react";
const SvgEditContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.049 3.352h-6a3.6 3.6 0 0 0-3.6 3.6v12a3.6 3.6 0 0 0 3.6 3.6h12a3.6 3.6 0 0 0 3.6-3.6v-6m-13.2 3.6 4.366-.88a1.2 1.2 0 0 0 .611-.328l9.774-9.78a1.2 1.2 0 0 0 0-1.697L20.128 1.8a1.2 1.2 0 0 0-1.697.001l-9.775 9.78a1.2 1.2 0 0 0-.327.61z"
    />
  </svg>
);
export default SvgEditContained;
